import {
  ACTION_POST_BOOKINGS_TRANSACTION_EMAIL,
  ACTION_POST_BOOKINGS_TRANSACTION_EMAIL_SUCCESS,
  ACTION_POST_BOOKINGS_TRANSACTION_EMAIL_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import { track } from '../../analytics/analytics';
import { enqueueSnackbarHandler } from '../Status';
import { Dispatch } from 'redux';
import * as _ from 'lodash-es';

export function sendBookingTransactionEmail(
  transactionId: string,
  additionalEmails: Array<string>,
) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());
    dispatch({
      type: API_CALL,
      payload: {
        call: `bookings/transactions/${transactionId}/sendemail`,
        method: 'post',
        data: JSON.stringify({
          additionalEmails,
        }),
        success: (response: any) => {
          if (response.type === 'error') {
            dispatch(requestFailed(response));
            _.get(response.payload.payload, 'userPermissionError', false)
              ? enqueueSnackbarHandler(
                  dispatch,
                  response.payload.payload,
                  'error',
                )
              : enqueueSnackbarHandler(
                  dispatch,
                  { bookingTransactionEmailFailed: true },
                  'error',
                );
          } else {
            dispatch(requestSuccess(response));
            handleTrack(transactionId, response.payload.email);
            enqueueSnackbarHandler(
              dispatch,
              { bookingTransactionEmailSent: true },
              'success',
            );
          }
        },
        fail: (error: any) => {
          _.get(error.payload, 'userPermissionError', false)
            ? enqueueSnackbarHandler(dispatch, error.payload, 'error')
            : enqueueSnackbarHandler(
                dispatch,
                { bookingTransactionEmailFailed: true },
                'error',
              );
          dispatch(requestFailed(error));
        },
      },
    });
    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_POST_BOOKINGS_TRANSACTION_EMAIL,
    payload: null,
  };
}

export function requestSuccess(responseJSON: any) {
  return {
    type: ACTION_POST_BOOKINGS_TRANSACTION_EMAIL_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: any) {
  return {
    type: ACTION_POST_BOOKINGS_TRANSACTION_EMAIL_FAILURE,
    payload: responseJSON,
  };
}

function handleTrack(transactionId: string, allEmails: [string]) {
  let properties = {
    'Transaction ID': transactionId,
    'Additional Emails': allEmails,
  };

  track('BB_BookingEmailed', properties);
}
